"use client";

import Image from "next/image";
import { useState } from "react";

// Wrapper de Image para fotos de egg-types: si la URL no carga (ej. el
// admin borró la foto pero el cache no se ha refrescado, o un egg-type
// nuevo no tiene foto aún), muestra un fallback con el color de la cáscara.
interface EggImageProps {
  src: string | null;
  alt: string;
  color?: string | null;
  className?: string;
  priority?: boolean;
}

const COLOR_FALLBACKS: Record<string, string> = {
  WHITE: "#F5F0E8",
  CREAM: "#EFE5D0",
  BROWN: "#C19A6B",
  RED: "#A0522D",
  BLUE: "#A3C9E0",
  GREEN: "#8FB58A",
  CHOCOLATE: "#5C3A21",
  SPECKLED: "#D4B896",
};

export default function EggImage({
  src,
  alt,
  color,
  className,
  priority,
}: EggImageProps) {
  const [errored, setErrored] = useState(false);
  const showFallback = !src || errored;

  if (showFallback) {
    const bg = (color && COLOR_FALLBACKS[color]) ?? "#EFE5D0";
    return (
      <div
        className={`flex items-center justify-center ${className ?? ""}`}
        style={{ backgroundColor: bg }}
        role="img"
        aria-label={alt}
      >
        <svg
          width="60"
          height="80"
          viewBox="0 0 60 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse
            cx="30"
            cy="44"
            rx="26"
            ry="34"
            fill="white"
            fillOpacity="0.6"
          />
        </svg>
      </div>
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      fill
      sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
      className={`object-cover ${className ?? ""}`}
      priority={priority}
      onError={() => setErrored(true)}
    />
  );
}
